/**
 * デフォルトのモジュールを読込
 */
import './Default';

/**
 * スライダー
 */
import { SliderModule } from './components/molecules/slider';
const $sliderModule = new SliderModule.Service();

/**
 * アコーディオン
 */
import { AccordionModule } from './components/molecules/accordion';
const $accordionModule = new AccordionModule.Service();

/**
 * メインヘッダー
 */
import { MainHeaderModule } from './components/organisms/mainHeader';
const $mainHeaderModule = new MainHeaderModule.Service();

/**
 * セレクトボックスでプレースホルダーを再現
 */
import { SelectBoxPlaceholderModule } from './components/molecules/SelectBoxPlaceholder';
const $selectBoxPlaceholderModule = new SelectBoxPlaceholderModule.Service();

/**
 * TOP map event
 */
import { EventContentBoxMainItemMapMainListItemLinkModule } from './page/top/eventContentBoxMainItemMapMainListItemLink';
const $eventContentBoxMainItemMapMainListItemLinkModule = new EventContentBoxMainItemMapMainListItemLinkModule.Service();

/**
 * LightboxModule
 */
 import { LightboxModule } from './components/molecules/lightbox';
 const $lightboxModule = new LightboxModule.Service();
 